"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'critical-actions/v1';

var CriticalActionsAPI =
/*#__PURE__*/
function () {
  function CriticalActionsAPI() {
    (0, _classCallCheck2.default)(this, CriticalActionsAPI);
  }

  (0, _createClass2.default)(CriticalActionsAPI, null, [{
    key: "exportCriticalActions",
    value: function exportCriticalActions() {
      return _apiClient.default.post(API_BASE + "/critical-actions/export", {
        data: {}
      });
    }
  }]);
  return CriticalActionsAPI;
}();

exports.default = CriticalActionsAPI;
module.exports = exports.default;